(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9396],{

/***/ 514:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "N": function() { return /* binding */ Fallback; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(1383);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(6829);
;// CONCATENATED MODULE: ./src/components/Fallback/Fallback.style.ts


var _templateObject;


var Fallback_style_Fallback = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding: 30px;\n"])));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./src/components/Fallback/Fallback.tsx



var Fallback = function Fallback(_ref) {
  var error = _ref.error;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Fallback_style_Fallback, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "An error has occurred."
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: error
    })]
  });
};

/***/ }),

/***/ 3018:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$": function() { return /* binding */ SocialMediaLinks; }
});

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(1383);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(6829);
;// CONCATENATED MODULE: ./src/components/SocialMediaLinks/SocialMediaLinks.style.ts


var _templateObject, _templateObject2;


var Links = emotion_styled_browser_esm/* default.ul */.Z.ul(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  align-items: center;\n  column-gap: 15px;\n  justify-content: ", ";\n\n  + button:first-of-type:not(:only-child) {\n    margin: 0;\n  }\n"])), function (_ref) {
  var isMobileNav = _ref.isMobileNav;
  return isMobileNav ? 'center' : "flex-start";
});
var Item = emotion_styled_browser_esm/* default.li */.Z.li(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  font-weight: bold;\n  margin-right: 20px;\n"])));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./src/components/SocialMediaLinks/SocialMediaLinks.tsx




var SocialMediaLinks = function SocialMediaLinks(_ref) {
  var isMobileNav = _ref.isMobileNav;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Links, {
    isMobileNav: isMobileNav,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Item, {
      children: "Follow Us Here"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
        href: "https://www.facebook.com/switchit.green",
        target: "_blank",
        rel: "noreferrer",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          src: '/icons/icon_follow_fb.svg',
          alt: "",
          width: 15,
          height: 29
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
        href: "https://www.instagram.com/switchit.green",
        target: "_blank",
        rel: "noreferrer",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          src: '/icons/icon_follow_instagram.svg',
          alt: "",
          width: 27,
          height: 27
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
        href: "https://twitter.com/switchit_green",
        target: "_blank",
        rel: "noreferrer",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          src: '/icons/icon_follow_twitter.svg',
          alt: "",
          width: 29,
          height: 23
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
        href: "https://www.linkedin.com/company/switchit-green",
        target: "_blank",
        rel: "noreferrer",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          src: '/icons/icon_follow_linkedin.svg',
          alt: "",
          width: 25,
          height: 26
        })
      })
    })]
  });
};

/***/ }),

/***/ 9106:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "B": function() { return /* binding */ SignedOutLayout; }
});

// EXTERNAL MODULE: ./node_modules/react-error-boundary/dist/react-error-boundary.umd.js
var react_error_boundary_umd = __webpack_require__(5800);
// EXTERNAL MODULE: ./src/components/Fallback/Fallback.tsx + 1 modules
var Fallback = __webpack_require__(514);
// EXTERNAL MODULE: ./src/hooks/useMediaQuery.ts
var useMediaQuery = __webpack_require__(6554);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/components/SocialMediaLinks/SocialMediaLinks.tsx + 1 modules
var SocialMediaLinks = __webpack_require__(3018);
// EXTERNAL MODULE: ./src/styles/common.style.ts
var common_style = __webpack_require__(8482);
// EXTERNAL MODULE: ./src/modules/SignedOutLanding/SignedOutLanding.style.ts
var SignedOutLanding_style = __webpack_require__(9596);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./src/modules/SignedOutLanding/Footer.tsx








var footerNav = [{
  text: 'Programs',
  route: '/students'
}, {
  text: 'About Us',
  route: '/about'
}, {
  text: 'Why Switch It Green?',
  route: '/why-switch-it-green'
}, {
  text: 'Contact Us',
  route: '/contact-us'
}];
var footerSubNav = [{
  text: 'Disclaimer',
  route: 'disclaimer'
}, {
  text: 'Privacy Policy',
  route: 'privacy-policy'
}, {
  text: 'Terms & Conditions',
  route: 'terms'
}];
var Footer = function Footer() {
  var year = new Date().getUTCFullYear();

  var _useMediaQuery = (0,useMediaQuery/* useMediaQuery */.a)(),
      isMobile = _useMediaQuery.isMobile;

  var igWidth = isMobile ? 100 : 160;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(SignedOutLanding_style/* Footer */.$_, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(SignedOutLanding_style/* FooterMain */.cC, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(SignedOutLanding_style/* FooterNavContainer */.WX, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SignedOutLanding_style/* FooterNavHeader */.i2, {
          children: "Switch It Green"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(SignedOutLanding_style/* FooterNav */.HW, {
          children: footerNav.map(function (_ref) {
            var text = _ref.text,
                route = _ref.route;
            return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                href: route,
                children: text
              })
            }, route);
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(SignedOutLanding_style/* Social */.g_, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(SignedOutLanding_style/* InstagramFeed */.Qk, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(common_style/* AnchorLink */.PN, {
            href: "https://www.instagram.com/switchit.green",
            target: "_blank",
            rel: "noreferrer",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
              src: '/images/img_igfeed1.jpeg',
              alt: "",
              width: igWidth,
              height: igWidth
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(common_style/* AnchorLink */.PN, {
            href: "https://www.instagram.com/switchit.green",
            target: "_blank",
            rel: "noreferrer",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
              src: '/images/img_igfeed2.jpeg',
              alt: "",
              width: igWidth,
              height: igWidth
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(common_style/* AnchorLink */.PN, {
            href: "https://www.instagram.com/switchit.green",
            target: "_blank",
            rel: "noreferrer",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
              src: '/images/img_igfeed3.jpeg',
              alt: "",
              width: igWidth,
              height: igWidth
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(SocialMediaLinks/* SocialMediaLinks */.$, {})]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(SignedOutLanding_style/* FooterSubnav */.r3, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SignedOutLanding_style/* Subnav */.G2, {
        children: footerSubNav.map(function (_ref2) {
          var text = _ref2.text,
              route = _ref2.route;
          return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
              href: route,
              children: text
            })
          }, route);
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        children: ["\xA9 ", year, " Switch It Green"]
      })]
    })]
  });
};
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(9499);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(4184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./src/state/nav/navSlice.ts
var navSlice = __webpack_require__(5335);
;// CONCATENATED MODULE: ./public/images/logo_switchit_teal.svg
/* harmony default export */ var logo_switchit_teal = ({"src":"/_next/static/media/logo_switchit_teal.92dba6b3.svg","height":33,"width":61});
;// CONCATENATED MODULE: ./src/modules/SignedOutLanding/MobileNavigation.tsx













var navigation = [{
  text: 'Why Switch It Green?',
  route: '/why-switch-it-green'
}, {
  text: 'About',
  route: '/about'
}, {
  text: 'Students',
  route: '/students'
}, {
  text: 'Donate',
  route: '/donate'
}];
var subNav = [{
  text: 'Sign In',
  route: '/api/auth/login'
}, {
  text: 'Get Started',
  route: '/api/auth/signup'
}];
var MobileNavigation = function MobileNavigation() {
  var dispatch = (0,es/* useDispatch */.I0)();

  var _useRouter = (0,router.useRouter)(),
      pathname = _useRouter.pathname;

  var _useSelector = (0,es/* useSelector */.v9)(function (state) {
    return state.nav;
  }),
      isWebsiteNavOpen = _useSelector.isWebsiteNavOpen;

  var isActive = function isActive(route) {
    return pathname === route || pathname.includes(route);
  };

  var toggleNav = function toggleNav() {
    dispatch((0,navSlice/* toggleWebsiteNav */.qz)());
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(SignedOutLanding_style/* MobileNavHeader */.cL, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
        href: "/",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            src: logo_switchit_teal,
            alt: "SwitchIt logo",
            width: 62,
            height: 33
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SignedOutLanding_style/* CloseMenu */.tf, {
        onClick: toggleNav,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          src: "/icons/icon_".concat(isWebsiteNavOpen ? 'close' : 'hamburger', ".svg"),
          alt: "Close",
          width: isWebsiteNavOpen ? 28 : 32,
          height: isWebsiteNavOpen ? 19 : 32
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(SignedOutLanding_style/* MobileNav */.zM, {
      isNavOpen: isWebsiteNavOpen,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(SignedOutLanding_style/* MobileNavHeader */.cL, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          onClick: toggleNav,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: "/",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                src: logo_switchit_teal,
                alt: "SwitchIt logo",
                width: 62,
                height: 33
              })
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(SignedOutLanding_style/* CloseMenu */.tf, {
          onClick: toggleNav,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            src: "/icons/icon_".concat(isWebsiteNavOpen ? 'close' : 'hamburger', ".svg"),
            alt: "Close",
            width: isWebsiteNavOpen ? 22 : 32,
            height: isWebsiteNavOpen ? 22 : 32
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SignedOutLanding_style/* MobileNavigation */.$o, {
        children: navigation.map(function (_ref) {
          var text = _ref.text,
              route = _ref.route;
          return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
            onClick: toggleNav,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
              href: route,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                className: classnames_default()((0,defineProperty/* default */.Z)({}, 'active', isActive(route))),
                children: text
              })
            })
          }, route);
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SignedOutLanding_style/* MobileNSubnav */.jD, {
        children: subNav.map(function (_ref2) {
          var text = _ref2.text,
              route = _ref2.route;
          return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
            onClick: toggleNav,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
              href: route,
              children: text
            })
          }, route);
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SocialMediaLinks/* SocialMediaLinks */.$, {
        isMobileNav: true
      })]
    })]
  });
};
// EXTERNAL MODULE: ./src/components/Navigation/Navigation.style.ts
var Navigation_style = __webpack_require__(8330);
;// CONCATENATED MODULE: ./src/modules/SignedOutLanding/Navigation.tsx









var Navigation_navigation = [{
  text: 'Why Switch It Green?',
  route: '/why-switch-it-green'
}, {
  text: 'About',
  route: '/about'
}, {
  text: 'Students',
  route: '/students'
}, {
  text: 'Donate',
  route: '/donate'
}, {
  text: 'Sign In',
  route: '/api/auth/login'
}];
var Navigation = function Navigation() {
  var _useRouter = (0,router.useRouter)(),
      pathname = _useRouter.pathname;

  var isActive = function isActive(route) {
    return pathname === route || pathname.includes(route);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(SignedOutLanding_style/* Nav */.JL, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Navigation_style/* Logo */.TR, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
        href: "/",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            src: '/images/logo_switchit_teal.svg',
            alt: "SwitchIt logo",
            width: 62,
            height: 33
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SignedOutLanding_style/* LogoName */.Yt, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          href: "/",
          children: "Switch It Green"
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(SignedOutLanding_style/* Navigation */.W_, {
      children: [Navigation_navigation.map(function (_ref) {
        var text = _ref.text,
            route = _ref.route;
        return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: route,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              className: classnames_default()((0,defineProperty/* default */.Z)({}, 'active', isActive(route))),
              children: text
            })
          })
        }, route);
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SignedOutLanding_style/* SignUp */.Mo, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          href: "/api/auth/signup",
          children: "Get Started"
        })
      })]
    })]
  });
};
;// CONCATENATED MODULE: ./src/modules/SignedOutLanding/SignedOutLayout.tsx










var SignedOutLayout = function SignedOutLayout(_ref) {
  var children = _ref.children;

  var _useMediaQuery = (0,useMediaQuery/* useMediaQuery */.a)(),
      isMobile = _useMediaQuery.isMobile;

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(react_error_boundary_umd.ErrorBoundary, {
      fallbackRender: function fallbackRender(_ref2) {
        var error = _ref2.error;
        return /*#__PURE__*/(0,jsx_runtime.jsx)(Fallback/* Fallback */.N, {
          error: error === null || error === void 0 ? void 0 : error.message
        });
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(SignedOutLanding_style/* Content */.VY, {
        children: [isMobile ? /*#__PURE__*/(0,jsx_runtime.jsx)(MobileNavigation, {}) : /*#__PURE__*/(0,jsx_runtime.jsx)(Navigation, {}), children, /*#__PURE__*/(0,jsx_runtime.jsx)(Footer, {})]
      })
    })
  });
};

/***/ }),

/***/ 2488:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _modules_PrivacyPolicy_PrivacyPolicy__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7603);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);



var PrivacyPolicyPage = function PrivacyPolicyPage() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_modules_PrivacyPolicy_PrivacyPolicy__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {});
};

/* harmony default export */ __webpack_exports__["default"] = (PrivacyPolicyPage);

/***/ }),

/***/ 4217:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/privacy-policy",
      function () {
        return __webpack_require__(2488);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5800:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(exports, __webpack_require__(7294)) :
  0;
})(this, (function (exports, React) { 'use strict';

  function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
      Object.keys(e).forEach(function (k) {
        if (k !== 'default') {
          var d = Object.getOwnPropertyDescriptor(e, k);
          Object.defineProperty(n, k, d.get ? d : {
            enumerable: true,
            get: function () { return e[k]; }
          });
        }
      });
    }
    n["default"] = e;
    return Object.freeze(n);
  }

  var React__namespace = /*#__PURE__*/_interopNamespace(React);

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    _setPrototypeOf(subClass, superClass);
  }

  var changedArray = function changedArray(a, b) {
    if (a === void 0) {
      a = [];
    }

    if (b === void 0) {
      b = [];
    }

    return a.length !== b.length || a.some(function (item, index) {
      return !Object.is(item, b[index]);
    });
  };

  var initialState = {
    error: null
  };

  var ErrorBoundary = /*#__PURE__*/function (_React$Component) {
    _inheritsLoose(ErrorBoundary, _React$Component);

    function ErrorBoundary() {
      var _this;

      for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
        _args[_key] = arguments[_key];
      }

      _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;
      _this.state = initialState;

      _this.resetErrorBoundary = function () {
        var _this$props;

        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        _this.props.onReset == null ? void 0 : (_this$props = _this.props).onReset.apply(_this$props, args);

        _this.reset();
      };

      return _this;
    }

    ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError(error) {
      return {
        error: error
      };
    };

    var _proto = ErrorBoundary.prototype;

    _proto.reset = function reset() {
      this.setState(initialState);
    };

    _proto.componentDidCatch = function componentDidCatch(error, info) {
      var _this$props$onError, _this$props2;

      (_this$props$onError = (_this$props2 = this.props).onError) == null ? void 0 : _this$props$onError.call(_this$props2, error, info);
    };

    _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
      var error = this.state.error;
      var resetKeys = this.props.resetKeys; // There's an edge case where if the thing that triggered the error
      // happens to *also* be in the resetKeys array, we'd end up resetting
      // the error boundary immediately. This would likely trigger a second
      // error to be thrown.
      // So we make sure that we don't check the resetKeys on the first call
      // of cDU after the error is set

      if (error !== null && prevState.error !== null && changedArray(prevProps.resetKeys, resetKeys)) {
        var _this$props$onResetKe, _this$props3;

        (_this$props$onResetKe = (_this$props3 = this.props).onResetKeysChange) == null ? void 0 : _this$props$onResetKe.call(_this$props3, prevProps.resetKeys, resetKeys);
        this.reset();
      }
    };

    _proto.render = function render() {
      var error = this.state.error;
      var _this$props4 = this.props,
          fallbackRender = _this$props4.fallbackRender,
          FallbackComponent = _this$props4.FallbackComponent,
          fallback = _this$props4.fallback;

      if (error !== null) {
        var _props = {
          error: error,
          resetErrorBoundary: this.resetErrorBoundary
        };

        if ( /*#__PURE__*/React__namespace.isValidElement(fallback)) {
          return fallback;
        } else if (typeof fallbackRender === 'function') {
          return fallbackRender(_props);
        } else if (FallbackComponent) {
          return /*#__PURE__*/React__namespace.createElement(FallbackComponent, _props);
        } else {
          throw new Error('react-error-boundary requires either a fallback, fallbackRender, or FallbackComponent prop');
        }
      }

      return this.props.children;
    };

    return ErrorBoundary;
  }(React__namespace.Component);

  function withErrorBoundary(Component, errorBoundaryProps) {
    var Wrapped = function Wrapped(props) {
      return /*#__PURE__*/React__namespace.createElement(ErrorBoundary, errorBoundaryProps, /*#__PURE__*/React__namespace.createElement(Component, props));
    }; // Format for display in DevTools


    var name = Component.displayName || Component.name || 'Unknown';
    Wrapped.displayName = "withErrorBoundary(" + name + ")";
    return Wrapped;
  }

  function useErrorHandler(givenError) {
    var _React$useState = React__namespace.useState(null),
        error = _React$useState[0],
        setError = _React$useState[1];

    if (givenError != null) throw givenError;
    if (error != null) throw error;
    return setError;
  }
  /*
  eslint
    @typescript-eslint/sort-type-union-intersection-members: "off",
    @typescript-eslint/no-throw-literal: "off",
    @typescript-eslint/prefer-nullish-coalescing: "off"
  */

  exports.ErrorBoundary = ErrorBoundary;
  exports.useErrorHandler = useErrorHandler;
  exports.withErrorBoundary = withErrorBoundary;

  Object.defineProperty(exports, '__esModule', { value: true });

}));
//# sourceMappingURL=react-error-boundary.umd.js.map


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7603,9774,2888,179], function() { return __webpack_exec__(4217); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);